import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { Table, Select } from 'antd';
import { TableContainer, PayMoney } from '@/components';
import mapping from '@/shared/mapping';
const Option = Select.Option;
const mapStateToProps = (rootState) => ({
    _state: rootState.cashMargin,
});
class MarginCash extends Component {
    constructor(props) {
        super(props);
        this.onChangeVal = (e) => {
            dispatch.cashMargin.onChange(e);
        };
        // 页码改变
        this.changePage = (page) => {
            // console.log(page,pageSize);
            dispatch.cashMargin.SET_STATE({
                pageIndex: page,
            });
            dispatch.cashMargin.load({});
        };
        this.cancel = () => {
            dispatch.cashMargin.HIDE_PAYCONFIRM();
        };
        this.ok = () => {
            dispatch.cashMargin.HIDE_PAYCONFIRM();
            dispatch.cashMargin.GET_CURRENT_PAGE();
            dispatch.cashMargin.load({ status: 0 });
        };
        this.state = {
            tableNum: [
                {
                    title: '序列',
                    dataIndex: 'index',
                    width: 150,
                    render: (text, record, index) => {
                        const { pageIndex, pageSize } = this.props._state;
                        return (<span>{(pageIndex - 1) * pageSize + index + 1}</span>);
                    },
                },
            ],
        };
    }
    componentWillMount() {
        dispatch.cashMargin.load({ status: 0 });
        dispatch.cashMargin.SET_STATE({
            activeState: '0',
        });
    }
    // 获取导出类型
    getExportType(status) {
        const { excelExportType } = this.props._state;
        const { withdraw_init_data, withdraw_accept_data, withdraw_reject_data } = excelExportType;
        let type;
        type = status === '0' ? withdraw_init_data : (status === '1' ? withdraw_accept_data : withdraw_reject_data);
        return type;
    }
    render() {
        const { totalNum, data, columns, loading, options, showPayConfirm, searchData, noApprovalData, pageSize, pageIndex, activeState, waitTableColumns, rejectTableColumns, passTableColumns, } = this.props._state;
        const { moneyY, id } = noApprovalData;
        const { distributorName, distributorPhone, startDate, endDate, } = searchData;
        const type = this.getExportType(activeState);
        const { label: fileName, value: exportType } = type;
        const exportObjParams = {
            startDate,
            endDate,
            mobile: distributorPhone,
            distributor: distributorName,
            exportType,
        };
        const { tableNum } = this.state;
        const tableColumns = [
            ...tableNum,
            ...columns,
            ...(activeState === '0' ? waitTableColumns : []),
            ...(activeState === '1' ? passTableColumns : []),
            ...(activeState === '2' ? rejectTableColumns : []),
        ];
        return (<React.Fragment>
        <TableContainer isTab totalNum={totalNum} exportObj={{
            type: 'finance',
            params: exportObjParams,
            fileName,
            allow: mapping.exportAllow.psgjb_finanwithdraw_export.value,
        }}>
          <Select onChange={this.onChangeVal} style={{ width: 200 }} defaultValue="0" getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
            {options.map((opt, i) => (<Option key={`opt_${i}`} value={opt.value}>{opt.label}</Option>))}
          </Select>
          <Table dataSource={data} columns={tableColumns} loading={loading} rowKey={(record) => record.id} pagination={{
            current: pageIndex,
            pageSize,
            showQuickJumper: true,
            total: totalNum,
            onChange: this.changePage,
        }}/>
        </TableContainer>
        <PayMoney isShow={showPayConfirm} orderId={id} price={moneyY} onCancel={this.cancel} onOk={this.ok} type={'applyRefund'}/>

      </React.Fragment>);
    }
}
export default connect(mapStateToProps)(MarginCash);
